export const UPDATE_COLUMN = "UPDATE_COLUMN";
export const RESET_COLUMN = "RESET_COLUMN";

export const updateColumn = () => ({
  type: UPDATE_COLUMN
});

export const resetColumn = () => ({
  type: RESET_COLUMN
});



// WEBPACK FOOTER //
// ./frontend/actions/column_actions.js